// extracted by mini-css-extract-plugin
module.exports = {"icon":"DatesSelect_icon__pHZcr","icon-reverse":"DatesSelect_icon-reverse__1owyb"};